import React, { useState } from 'react';
import { LoadingOutlined } from "@ant-design/icons";
import { identity } from "../../utils/getIdentity";
import { Spin, Row, Col } from "antd";
import './style.scss';
import { ReactComponent as RemoveIcon } from "../../img/adminPanel/remove.svg";
import editSVG from '../../img/default-svg/edit.svg';
import editSVGInex from '../../img/inex/edit.svg';
import editSVGInsta from '../../img/instaXchange/edit.svg';
import editSVGCoinera from '../../img/coinera/edit.svg';
import { truncate } from "../../utils/truncateFunction";
import DeleteAddress from "./DeleteAddress";
import useWindowSize from "../../utils/resizeHook";
import AvatarAddressBook from "./AvatarAddressBook";
import { useTranslation } from "react-i18next";

const editIcon = {
  cpay: editSVG,
  nfg: editSVG,
  finvaro: editSVG,
  clarnium: editSVG,
  inex: editSVGInex,
  insta: editSVGInsta,
  coinera: editSVGCoinera
}

const AddressBookList = ({ addressBook, deleteAddressBook, addressBookList, setUser }) => {
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState('');

  const { currentWidth } = useWindowSize();

  const { t } = useTranslation();

  const handleOpenDeleteModal = (id) => {
    setIsOpenDeleteModal(true);
    setDeleteId(id);
  };

  const handleDeleteAddress = () => {
    deleteAddressBook(deleteId).then(res => {
      setIsOpenDeleteModal(false);
      setDeleteId('');
      addressBookList();
    })
  }

  return (
    <div>
      {addressBook?.fetching ? (
        <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 20 }} spin />} />
      ) : (
        <div>
          {addressBook?.entities?.length === 0 ? (
            <div className="address-book__empty">{t('addressBook.empty_list')}</div>
          ) : (
            <>
              {addressBook?.entities?.map((item, i) => (
                <Row className="address-book__row" key={i}>
                  <Col span={currentWidth > 630 ? 1 : 2}><AvatarAddressBook width='24px' height='24px' name={item.name} index={i} /></Col>
                  <Col span={currentWidth > 630 ? 7 : 12} className="address-book__col">
                    {item?.name}
                  </Col>
                  <Col className="address-book__nodeType" span={currentWidth > 630 ? 6 : 10}>{item?.wallets[0]?.nodeType?.toUpperCase()}</Col>
                  <Col className="address-book__address" span={currentWidth > 630 ? 8 : 14}>{truncate(item?.wallets[0]?.address, 14, '..')}</Col>
                  <Col className="address-book__edit" span={currentWidth > 630 ? 2 : 10}>
                    <div className="address-book__icons">
                      <img src={editIcon[identity]} alt="" onClick={() => setUser(item)} />
                      <RemoveIcon onClick={() => handleOpenDeleteModal(item?._id)} />
                    </div>
                  </Col>
                </Row>
              ))}
            </>
          )}
        </div>
      )}

      <DeleteAddress handleDeleteAddress={handleDeleteAddress} visible={isOpenDeleteModal} close={() => setIsOpenDeleteModal(false)} />
    </div>
  )
};

export default AddressBookList;